import React, { useState, useEffect } from 'react';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import '../../Slider/Slider.css';
import { useSelector } from 'react-redux';
import { compareTime, convertFromMinutesSinceMidnight, convertToMinutesSinceMidnight, convertToTimeFormat } from '../../../../utils';
import timeDiffernce from '../../../../utils';


const TimeRangeSlider = ({ selectedMinTime, selectedMaxTime, onTimeChangeProp, isReset }) => {


  // debugger;
  const minTime = convertToTimeFormat("00:00:00")
  const maxTime = convertToTimeFormat("23:59:00")

  const [tooltipValues, setTooltipValues] = useState([null, null]);
  const [dragging, setDragging] = useState(false);

  const [timeRange, setTimeRange] = useState([
    selectedMinTime || minTime,
    selectedMaxTime || maxTime,
  ]);

  useEffect(() => {
    // Update the timeRange state when the selectedMinTime or selectedMaxTime props change
    // debugger;
    setTimeRange([selectedMinTime || minTime, selectedMaxTime || maxTime]);

    // Update tooltip values when the selectedMinTime or selectedMaxTime props change
    setTooltipValues([
      selectedMinTime ? selectedMinTime : null,
      selectedMaxTime ? selectedMaxTime : null,
    ]);
  }, [selectedMinTime, selectedMaxTime]);


  const onTimeChange = (values) => {
    // debugger;
    // Convert values to time objects
    const timeValues = values.map((value) => convertFromMinutesSinceMidnight(value));
    // Extract the minimum and maximum dates from the 'timeValues' array
    const [time1, time2] = timeValues;

    // Enforce the constraint: emdTime should not be before startTime
    if (compareTime(time1, time2) === 1) {
      // debugger;
      // If the maxTime is less than the minTime, swap values to prevent reversal
      timeValues[0] = time2;
      timeValues[1] = time1;
    }

    setTimeRange(timeValues);
    setTooltipValues(timeValues.map((value) => value));
    onTimeChangeProp(timeValues[0], timeValues[1]);
  };

  const tooltipFormatter = (value, index) => {
    // debugger;
    if (tooltipValues[index] !== null && dragging) {
      // If the tooltip value is not null and dragging is true, show the tooltip
      return value;
    } else {
      // Otherwise, hide the tooltip
      return '';
    }
  };


  //Calculate left % for Slider1 and Slider2
  const time1 = convertToMinutesSinceMidnight(timeRange[0]);
  const time2 = convertToMinutesSinceMidnight(timeRange[1]);
  const timeMin = convertToMinutesSinceMidnight(minTime);
  const timeMax = convertToMinutesSinceMidnight(maxTime);
  const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
  // const leftPercentageSlider1 = ((time1 - timeMin) / (time2-(120) - timeMin)) * 100;
  // const leftPercentageSlider2 = ((time2 - timeMin) / (timeMax - timeMin)) * 100;
  const leftPercentageSlider1 = ((time1 - timeMin) / (timeMax - timeMin)) * 100;
  const leftPercentageSlider2 = ((time2 - timeMin) / (timeMax - timeMin)) * 100;


  const handleStyle = {
    borderColor: '#2965FB',
    backgroundColor: '#2965FB',
    cursor: 'pointer'
  };

  return (
    <div className='flex justify-center w-full lg:w-[60%]'>
      <div className='w-[90%] lg:w-full '>
        <div className="slider-tooltips">
          {/* Custom tooltips for the slider handles */}
          <div className="flex pb-4 relative">
           <div
  className={`font-mono text-[14px] font-normal ${kudzuPlusTrue ? 'slider-tooltip-plus' : 'slider-tooltip-basic' }`}
  style={{
    left: `${(leftPercentageSlider1 + leftPercentageSlider2) / 2}%`,
    width: `calc(${leftPercentageSlider2 - leftPercentageSlider1}% + 50px)`
  }}
>

              <div className="h-full flex items-center sliderTimetext">
                {tooltipValues[0] !== null && tooltipValues[1] !== null && `${tooltipValues[0]} - ${tooltipValues[1]}`}
              </div>
              {/* Caret arrows at the edges of the block pointing to slider handles */}
              <div
  className={`sliderCaret ${
    kudzuPlusTrue ? 'sliderCaretPlus' : 'sliderCaretBasic'
  }`}
  style={{ left: 'var(--slider-left-handle-offset)' }}
/>
             <div
  className={`sliderCaret ${
    kudzuPlusTrue ? 'sliderCaretPlus' : 'sliderCaretBasic'
  }`}
  style={{ right: 'var(--slider-right-handle-offset)' }}
/>
            </div>
          </div>
        </div>

        <div className=' flex flex-row gap-0 items-center'>
         <div className=' w-[14px] h-[14px] -mr-1 rounded-full bg-[var(--transactions-filter-range-bg)]' />
          <Slider
            min={convertToMinutesSinceMidnight(minTime)}
            max={convertToMinutesSinceMidnight(maxTime)}
            value={timeRange.map((time) => convertToMinutesSinceMidnight(time))}
            onChange={(values) => {
              setTimeRange(values.map((value) => convertFromMinutesSinceMidnight(value)));
              onTimeChange(values);
            }}
            onBeforeChange={() => setDragging(true)}
            onAfterChange={() => setDragging(false)}
            step={1}
            tipFormatter={(value, index) => tooltipFormatter(value, index)}
            range
            allowCross={false}
            handleStyle={[
              handleStyle,
              {
                ...handleStyle,
                cursor: compareTime(timeRange[1], maxTime) === 1 ? 'not-allowed' : 'pointer',
              }, // Disable handle 1 on max date
            ]}
            railStyle={{ backgroundColor: 'var(--transactions-filter-range-bg' }} // Custom rail color
            trackStyle={[{ backgroundColor: 'var(--transactions-filter-tooltip-bg)' }]} // Blue track between handles
          />

        <div className=' w-[14px] h-[14px] -ml-1 rounded-full bg-[var(--transactions-filter-range-bg)]' />
        </div>

        <div className="flex pt-4">
          <div className="font-hanken-grotesk text-[var(--TootipText)] block w-[50%] text-[12px] leading-[12px] font-[500] md:text-[12px] md:leading-[12px] sm:text-[11px] sm:leading-[11px] sm:font-medium">
            {minTime}
          </div>
          <div className="font-hanken-grotesk text-[var(--TootipText)] block w-[50%] text-[12px] leading-[12px] font-[500] md:text-[12px] md:leading-[12px] sm:text-[11px] sm:leading-[11px] sm:font-medium text-right">
            {maxTime}
          </div>
        </div>

      </div>

    </div>
  );
};

export default TimeRangeSlider;
